<template>
  <transition>
    <div id="alertBar" class="row m-0 alertbar-container align-items-center">
      <ul class="moons">
        <li>
          <img class="moon-1" src="../../assets/img/moon-alertbar.svg" alt />
        </li>
        <li>
          <img class="moon-2" src="../../assets/img/moon-alertbar.svg" alt />
        </li>
        <li>
          <img class="moon-3" src="../../assets/img/moon-alertbar.svg" alt />
        </li>
        <li>
          <img class="moon-2" src="../../assets/img/moon-alertbar.svg" alt />
        </li>
      </ul>
      <div class="col-7 text-content pr-1">
        <p class="m-0">
          <span>Publique seu site</span> no seu endereço www profissional
        </p>
      </div>
      <div class="col button-content pl-1">
        <button class="btn py-1" @click="goToCheckout">Ative agora</button>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "alertBar",
  data() {
    return {
      message: "",
    };
  },
  methods: {
    goToCheckout() {
      var token = this.$store.state.siteActive.contract.token;
      if (token) {
        this.$router.push(`/checkout?token=${token}`);
      }
    },
  },
};
</script>

<style scoped>
.moons {
  display: none;
}
.alertbar-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: var(--main-color);
  color: #ffffff;
  font-size: 12px;
  height: 69px;
  z-index: 2;
  font-family: "Montserrat", sans-serif;
}
.alertbar-container span {
  font-weight: 700;
  font-size: 16px;
  display: block;
}
.alertbar-container .text-content {
  text-align: left;
  z-index: 2;
}
.alertbar-container .button-content {
  text-align: right;
  z-index: 2;
}
.alertbar-container button {
  background-color: #ffffff;
  border-radius: 40px;
  color: var(--main-color);
  font-weight: 700;
  font-size: 14px;
  padding-left: 20px;
  padding-right: 20px;
}
@media screen and (min-width: 994px) {
  .moons {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    padding: 0;
    z-index: 1;
  }
  .moons li {
    position: absolute;
    list-style: none;
    display: block;
    width: 40px;
    height: 40px;
    animation: moons-motion 580s infinite;
    -webkit-animation: moons-motion 580s infinite;
  }
  .moons li:nth-child(1) {
    left: 30%;
    top: -15px;
  }
  .moons li:nth-child(2) {
    left: 70%;
    top: 20%;
  }
  .moons li:nth-child(3) {
    left: 90%;
    top: 35%;
  }
  .moons li:nth-child(4) {
    left: 10%;
    top: 45%;
  }
  .moon-1 {
    width: 38px;
  }
  .moon-2 {
    width: 21px;
  }
  .moon-3 {
    width: 29px;
  }
  .alertbar-container span {
    display: inline-block;
  }
  .alertbar-container {
    font-size: 16px;
    height: 56px;
  }
  .alertbar-container .text-content {
    text-align: right;
  }
  .alertbar-container .button-content {
    text-align: left;
  }
  .alertbar-container button {
    margin: 0 0 0 25px;
    font-size: 16px;
    padding-left: 35px;
    padding-right: 35px;
  }
}
@keyframes moons-motion {
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(1000px);
  }
  100% {
    transform: translateX(0px);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/molecules/AlertBar.vue